var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LockableTd from "./LockableTd";
import { classNames } from "../Util";
import TableBodyRowWrapper from "./TableBodyRowWrapper";
var TableBodyRow = function (_a) {
    var dataRowIndex = _a.dataRowIndex, columns = _a.columns, onRowClick = _a.onRowClick, tableData = _a.tableData, draggableTableBodyRowProps = _a.draggableTableBodyRowProps;
    return (_jsx(TableBodyRowWrapper, __assign({ draggableTableBodyRowProps: draggableTableBodyRowProps, index: dataRowIndex }, { children: function (provided, snapshot) { return (_jsx("tr", __assign({ className: classNames("bg-white border-gray-200", onRowClick ? "hover:bg-gray-50 cursor-pointer" : "", (snapshot === null || snapshot === void 0 ? void 0 : snapshot.isDragging) ? "border rounded-md" : "border-y last:border-y-0 last:border-t"), onClick: function () { return onRowClick && onRowClick(tableData, dataRowIndex); } }, provided === null || provided === void 0 ? void 0 : provided.draggableProps, { ref: provided === null || provided === void 0 ? void 0 : provided.innerRef }, { children: columns.map(function (col, index) {
                if (col.hidden) {
                    return _jsx(React.Fragment, {}, index);
                }
                return (_jsx(LockableTd, { col: col, contents: tableData[col.name], colIndex: index, nColumns: columns.length, dragHandleProps: __assign({}, provided === null || provided === void 0 ? void 0 : provided.dragHandleProps), isDragging: (draggableTableBodyRowProps === null || draggableTableBodyRowProps === void 0 ? void 0 : draggableTableBodyRowProps.draggingRowIndex) === dataRowIndex }, index));
            }) }))); } })));
};
export default TableBodyRow;
